import ApplicationAdapter from "./application";

export default class InstanceDatabaseAdapter extends ApplicationAdapter {
  urlForDeleteRecord(id: string): string {
    return `${this.apiBaseUri}/database/deletedatabase?databaseid=${id}`;
  }
}
